import React from "react";

import { SimpleListProps } from "./SimpleList.types";
import { useStyles } from "./SimpleList.styles";

function SimpleList(props: SimpleListProps) {
  const { children } = props;

  const classes = useStyles();

  return <ul className={classes.root}>{children}</ul>;
}

export default SimpleList;
